import {ResponsePageInfo} from '../wa-response/wa-response-page-info';


export class ResponseData {

  protected rawItems: any[]
  protected pageInfo: ResponsePageInfo;
  protected error: boolean;

  constructor(rawResponseData: any, error: boolean = false) {
    this.rawItems = rawResponseData.items;
    this.pageInfo = new ResponsePageInfo(rawResponseData.pageInfo);
    this.error = error;
  }

  public isErroneous() {
    return this.error;
  }

  public getRawItems(): any[] {
    return this.rawItems;
  }

  public getPageInfo(): ResponsePageInfo {
    return this.pageInfo;
  }
}